import React, { useState } from 'react';
import { motion } from 'framer-motion';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const navigationItems = [
    {
      title: "Home",
      id: "home",
    },
    {
      title: "About",
      id: "about",
      description: "Learn about our mission and vision",
      items: [
        {
          title: "Our Story",
          id: "about",
        },
        {
          title: "Our Mission",
          id: "about",
        },
        {
          title: "Our Team",
          id: "team",
        },
      ],
    },
    {
      title: "Services",
      id: "services",
      description: "Explore our agricultural consulting services",
      items: [
        {
          title: "Skills Development",
          id: "services",
        },
        {
          title: "Governance Advisory",
          id: "services",
        },
        {
          title: "Workforce Training",
          id: "services",
        },
        {
          title: "Farm Management",
          id: "services",
        },
      ],
    },
    {
      title: "Contact",
      id: "contact",
    },
  ];

  return (
    <header className="w-full z-40 fixed top-0 left-0 bg-white shadow-sm">
      <div className="container mx-auto px-4 min-h-20 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3">
          <div className="h-12 w-12 flex items-center justify-center bg-green-100 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-700" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <div>
            <h1 className="text-xl font-bold text-green-800">
              Nqobimphilo Creations
            </h1>
            <p className="text-sm text-gray-600 hidden sm:block">
              Agricultural Consulting Excellence
            </p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navigationItems.map((item) => (
            <button
              key={item.title}
              onClick={() => scrollToSection(item.id)}
              className="text-gray-700 hover:text-green-700 font-medium transition-colors duration-200 relative group"
            >
              {item.title}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-green-700 transition-all duration-200 group-hover:w-full"></span>
            </button>
          ))}
          <motion.button
            onClick={() => scrollToSection('contact')}
            className="bg-green-700 text-white px-6 py-2 rounded-full hover:bg-green-800 transition-colors duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Consultation
          </motion.button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden p-2 text-gray-700"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="w-6 h-6" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t shadow-lg">
          <div className="container mx-auto px-4 py-4 space-y-4">
            {navigationItems.map((item) => (
              <div key={item.title} className="py-2">
                <button
                  onClick={() => scrollToSection(item.id)}
                  className="text-lg font-medium text-gray-800 hover:text-green-700"
                >
                  {item.title}
                </button>
                {item.items && (
                  <div className="ml-4 mt-2 space-y-2">
                    {item.items.map((subItem) => (
                      <button
                        key={subItem.title}
                        onClick={() => scrollToSection(subItem.id)}
                        className="block text-gray-600 hover:text-green-700"
                      >
                        {subItem.title}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full bg-green-700 text-white py-3 rounded-lg hover:bg-green-800 transition-colors duration-200"
            >
              Get Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;